// These values relate to the default of CreatorShopProductTile.vue component
const titleLineHeight = 24;
const subtitleLineHeight = 20;
const textContentPadding = 12;
const textContentPaddingTopAndBottom = textContentPadding * 2;
const topAndBottomBorder = 2;

const getProductTileHeight = ({
  width,
  withTitle,
  withSubtitle,
}: {
  width: number;
  withTitle: boolean;
  withSubtitle: boolean;
}) =>
  width +
  textContentPaddingTopAndBottom +
  topAndBottomBorder +
  (withTitle ? titleLineHeight : 0) +
  (withSubtitle ? subtitleLineHeight : 0);

export const getProductTileDimensions = ({
  width,
  columns,
  gap,
  withTitle = true,
  withSubtitle = true,
}: {
  width: number;
  columns: number;
  gap: number;
  withTitle?: boolean;
  withSubtitle?: boolean;
}): Array<number> => {
  const spaceBetweenColumnsDistributed = (gap * (columns - 1)) / columns;
  const itemWidth = width / columns - spaceBetweenColumnsDistributed;
  const itemHeight = getProductTileHeight({ width: itemWidth, withTitle, withSubtitle });
  return [itemHeight, itemWidth];
};
